var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Button',{attrs:{"tag":"router-link","to":{ name: 'scheduleCreate' },"icon-left":"plus"}},[_vm._v(" "+_vm._s(_vm.$t('schedules.create'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }